<template>
  <div>
    <h2>Verbotene Wörter</h2>
    <p class="mb-3">
      Folgende Wörter werden innerhalb der Juniti App unterdrückt.
      Senden von Nachrichten in der App die eines dieser Wörter beinhalten ist nicht möglich.
    </p>
    <form class="form-group mb-3" @submit.prevent="addBadWords">
      <label for="words-input">Wörter hinzufügen<br><small><i>Separiert durch Leerzeichen oder Komma. Groß- und
        Kleinschreibung ist nicht relevant.</i></small></label>
      <input autofocus
             type="text"
             class="form-control"
             id="words-input"
             placeholder="verdammt, mist, ..."
             v-model="badWordsInputValue">
    </form>
    <h3>Liste aller Wörter</h3>
    <ul class="list-group">
      <li class="list-group-item"
          v-for="badWord in badWords"
          :key="badWord.id">
        {{ badWord.word }}
        <span aria-hidden="true"
              @click="deleteBadWord(badWord)">
          <img src="../../assets/icons/trash.svg" aria-hidden="true">
          </span>
      </li>
    </ul>
  </div>
</template>

<script>
import {communicator} from "@/util/communicator.js";
import {broadcast} from "@/util/eventHandler.js";

/**
 * @typedef {Object} BadWord
 * @property {string} word
 * @property {number} id
 */

export default {
  name: "BadWords",
  data() {
    return {
      badWords: [],
      badWordsInputValue: "" // words are comma separated
    };
  },
  created() {
    this.fetchBadWords();
  },
  methods: {
    async fetchBadWords() {
      try {
        const response = await communicator.get("/bad-words");
        this.badWords = response.data.badWords;
      } catch (e) {
        broadcast("error", e.response.data);
      }
    },
    /**
     * @param {BadWord} badWord
     */
    async deleteBadWord(badWord) {
      try {
        await communicator.delete(`/bad-words/${badWord.id}`);
        const index = this.badWords.findIndex(badWord2 => badWord2.id === badWord.id);
        if (index !== -1) {
          this.badWords.splice(index, 1);
        }
        await this.fetchBadWords();
      } catch (e) {
        broadcast("error", e.response.data);
      }
    },

    async addBadWords() {
      try {
        const postPromises = this.badWordsInputValue
            .split(",")
            .map(word => word.trim())
            .filter(word => word)
            .map(word => communicator.post("/bad-words", {word}));
        await Promise.all(postPromises);
        this.badWordsInputValue = "";
        await this.fetchBadWords();
      } catch (e) {
        broadcast("error", e.response.data);
      }
    }
  }
};
</script>

<style scoped>
.list-group-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.list-group-item span {
  display: block;
}

.list-group-item span:hover {
  cursor: pointer;
  transform: scale(1.2);
}
</style>
